import { PREVIOUS_PATH_FOR_BR_EMPTY_VALUE } from "~/constants/bloomreach";
import { checkRefUrlFlag } from "~/utils/data/bloomreach/check-ref-url-flag/check-ref-url-flag";

import { getRefUrlFromCookie } from "../bloomreach/get-ref-url-from-cookie/get-ref-url-from-cookie";
import { DetailedPageType } from "../bloomreach/types";

export const getRefUrlClient = (
  pageLocale?: string,
  pageType?: DetailedPageType,
) => {
  //NOTE: Delete entire dependency from pageLocale and AzureConfigurator after finishing work with (DIGIX-17933 Re-Integrate br_uid_2 and ref_url)
  if (pageLocale) {
    const isBloomreachRefUrl = checkRefUrlFlag(pageLocale, pageType);

    if (!isBloomreachRefUrl) {
      return PREVIOUS_PATH_FOR_BR_EMPTY_VALUE;
    }
  }

  return getRefUrlFromCookie();
};
